// @flow
import type {Element} from 'react'
import React from 'react'

import Item from '../../../Item'
import List from './List'

export type MoveItemsProps = {
  policiesToMoveUp: Item[],
  rolesToMoveUp: Item[],
  policiesToMoveDown: Item[],
  rolesToMoveDown: Item[],
  ...
}

function MoveItems(props: MoveItemsProps): Element<"div"> {
  const {
    policiesToMoveUp,
    rolesToMoveUp,
    policiesToMoveDown,
    rolesToMoveDown,
  } = props

  return (
    <div className="proposal-summary-move-items">
      <List
        changeKey="policies-to-move-up"
        list={policiesToMoveUp}
        movingOut
        title={I18n.t('proposal.policies_moving_out')}
      />
      <List
        changeKey="roles-to-move-up"
        list={rolesToMoveUp}
        movingOut
        title={I18n.t('proposal.roles_moving_out')}
      />
      <List
        changeKey="policies-to-move-down"
        list={policiesToMoveDown}
        movingIn
        title={I18n.t('proposal.policies_moving_in')}
      />
      <List
        changeKey="roles-to-move-down"
        list={rolesToMoveDown}
        movingIn
        title={I18n.t('proposal.roles_moving_in')}
      />
    </div>
  )
}

export default MoveItems
